//TODO need to be updated with all possible values
export enum EndorsementStatusCode {
  SIGNED = 'SIGNED',
  SIGNABLE = 'SIGNABLE'
}
